var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',[_c('md-layout',[_c('h2',[_vm._v("Peer Connections")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100"}},_vm._l((_vm.peerConnections),function(peer){return _c('md-image',{key:peer.id,staticClass:"connectionImage",attrs:{"md-src":peer.image}})}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f8a81aa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/ConnectionOverview.vue
// module id = 876
// module chunks = 0